import { encodePlayerName } from '~/redux/ducks/playersAndTeams/filter/selectors/getFiltersAsCayenneParams';
import { fetchStatsData } from '~/utility/requests';

const convertToSelectablePlayers = (players) =>
    players.map((player) => ({
        value: player.id,
        label: `${player.firstName} ${player.lastName}`,
        key: player.id,
    }));

const getPlayers = async (playerName, reportCategory) => {
    if (!playerName) {
        return [];
    }

    // We will allow the user to select a string shorter than 4 characters
    const defaultPlayer = [{ value: playerName, label: playerName, key: playerName }];
    if (playerName.length < 4) {
        return defaultPlayer;
    }

    try {
        const position =
            reportCategory === 'skater'
                ? encodeURIComponent(" and positionCode <> 'G'")
                : encodeURIComponent(" and positionCode = 'G'");

        const playerSearch = encodePlayerName(playerName, 'fullName', true);
        const playersUrl = `${window.__BASE_REST_URL__}/players?cayenneExp=${playerSearch}${position}`;
        const { data } = await fetchStatsData(playersUrl);
        const playerExist = data.find((p) => p.fullName.toUpperCase() === playerName.toUpperCase());
        return playerExist ? convertToSelectablePlayers(data) : [...defaultPlayer, ...convertToSelectablePlayers(data)];
    } catch (error) {
        return defaultPlayer;
    }
};

export default getPlayers;
